import * as types from './actionTypes';

export function getEnvironmntSuccess(data) {
    return {
      type: types.GET_ENVIRONMENT_SUCCESS,
      data
    };
  }